module.exports = __webpack_public_path__ + "img/SOKAL-WEB-112322-CreativeAnalysis-Cadillac-Lifestyle.21d40d37.jpeg";